<template>
  <div class="has-bg-white is-border">
    <div class="is-tab-like is-border-bottom is-vcentered is-tab-like">
      <a v-if="statsEnabled"
         class="button is-white is-transform-none is-padding-left-xsmall is-padding-right-xsmall is-margin-left-xsmall"
         :class="{'is-active' : panel === 'ACTIVITY'}" @click="changePanel(PANELS.ACTIVITY)">
        <span class="is-size-3">Activité Structure</span>
      </a>
      <a
              class="button is-white is-transform-none is-padding-left-xsmall is-padding-right-xsmall"
              :class="{'is-active' : panel === 'MONITORING'}" @click="changePanel(PANELS.MONITORING)">
        <span class="is-size-3">Monitoring</span>
      </a>
    </div>
    <component :is="panelComponent"
               :users-count="usersCount"
               :users="users"
               :companies="companies"
               :programs="programs"
               :lots="lots"
               :running-options="runningOptions"
               :pending-options="pendingOptions"
               :pending-denunciations="pendingDenunciations"
               :period-sales="sales"
               :previous-period-sales="[]"
               :end-date="endDate"
               :start-date="startDate"
               :year-sales="yearSales"
               :future-rdv="futureRdv"
               :future-rdv-count="futureRdvCount"
               @updateStartDate="updateStartDate"
               @updateEndDate="updateEndDate"
    ></component>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'
  import { isNil } from 'lodash'
  import StatsActivity from './stats-panel/StatsActivity'
  import StatsMonitoring from './stats-panel/StatsMonitoring'

  const PANELS = Object.freeze({
    MONITORING: 'MONITORING',
    ACTIVITY: 'ACTIVITY'
  })

  export default {
    name: 'DashboardStats',
    apollo: {
      stats: {
        query: gql`query getDashboardStats($token: String, $programStatus: [String], $lotStatus: [String]){
          dashboardStats(token: $token, programStatus: $programStatus, lotStatus: $lotStatus)
          {programsCount, lotsCount, companiesCount}
        }`,
        variables () {
          return {
            token: this.token,
            programStatus: ['available', 'private'],
            lotStatus: ['available', 'optioned']
          }
        },
        update (data) {
          return data.dashboardStats
        },
        skip () {
          return isNil(this.token)
        }
      },
      yearSales: {
        query: gql`
          query getYearSales($token: String, $startDate: String, $endDate: String, $status: [String]){
          salesStats(token: $token, startDate: $startDate, endDate:$endDate, status: $status){
          sales{sale_price, status, seller_share, remuneration, sale_price_with_discount, seller, seller_name}}
          }
        `,
        variables () {
          return {
            status: ['sold', 'reserved', 'canceled_by_admin'],
            token: this.token,
            startDate: this.startDate.clone().startOf('year').format('DD/MM/YYYY'),
            endDate: this.endDate.clone().endOf('year').format('DD/MM/YYYY')
          }
        },
        update (data) {
          return data.salesStats.sales
        },
        skip () {
          return isNil(this.token)
        }
      },
      // sales: {
      //   query: gql`
      //     query getSales($token: String, $startDate: String, $endDate: String, $status: [String]){
      //     salesStats(token: $token, startDate: $startDate, endDate:$endDate, status: $status){
      //     sales{sale_price, status, seller_share, remuneration, sale_price_with_discount, seller, seller_name, company, company_name}}
      //     }`,
      //   variables () {
      //     return {
      //       status: ['sold', 'reserved', 'canceled_by_admin'],
      //       token: this.token,
      //       startDate: this.startDate.clone().startOf('month').format('DD/MM/YYYY'),
      //       endDate: this.today.clone().endOf('day').format('DD/MM/YYYY')
      //     }
      //   },
      //   update (data) {
      //     return data.salesStats.sales
      //   },
      //   skip () {
      //     return true
      //   }
      // },
      users: {
        query: gql`query getUsers($token: String, $profils: [String], $page: Int){
          users(profils: $profils, token: $token, page: $page){
            pages, page, users{
              pk, first_name, last_name, email, picture{path, cloudinary_id}, goals{year, goal}
            }
          }
        }`,
        variables () {
          return {
            page: 1,
            token: this.token
          }
        },
        result (res) {
          let data = res.data
          if (data.users.page < data.users.pages) {
            this.loadMoreUsers(data.users.page + 1)
          }
        },
        update (data) {
          return data.users.users
        },
        skip () {
          return isNil(this.token)
        }
      }
    },
    components: { StatsActivity, StatsMonitoring },
    data () {
      return {
        pendingDenunciations: [],
        stats: null,
        denunciations: null,
        users: [],
        sales: [],
        token: null,
        previousSales: [],
        yearSales: [],
        futureRdv: [],
        futureRdvCount: null,
        rawStartDate: null,
        rawEndDate: null,
        today: moment(),
        panel: null,
        PANELS: PANELS
      }
    },
    computed: {
      ...mapState(['runningOptions', 'runningDenunciations']),
      ...mapGetters(['pendingOptions']),
      statsEnabled () {
        return JSON.parse(this.$configs.STATS_ENABLED) === 1
      },
      panelComponent () {
        const components = {
          [PANELS.ACTIVITY]: 'StatsActivity',
          [PANELS.MONITORING]: 'StatsMonitoring'
        }
        return components[this.panel]
      },
      startDate () {
        return moment(this.rawStartDate)
      },
      endDate () {
        return moment(this.rawEndDate)
      },
      programs () {
        if (this.stats) {
          return this.stats.programsCount
        }
        return null
      },
      lots () {
        if (this.stats) {
          return this.stats.lotsCount
        }
        return null
      },
      companies () {
        if (this.stats) {
          return this.stats.companiesCount
        }
        return null
      },
      usersCount () {
        return this.users.length
      }
    },
    methods: {
      changePanel (panel) {
        this.panel = panel
      },
      async loadData () {
        this.loadPendingDenunciationsCount()
        this.loadUsersCount()
        this.loadFutureRdvs()
        this.sales = await this.loadSales()
      },
      async loadSales () {
        let soldQuery = {
          'cached': 1,
          'status': 'sold',
          'sale_date__gte': this.startDate.clone().startOf('month').format('DD/MM/YYYY'),
          'sale_date__lte': this.today.clone().endOf('day').format('DD/MM/YYYY')
        }
        let soldRequest = await this.$api.advService.get(soldQuery)

        let reservedQuery = {
          'cached': 1,
          'status': 'reserved',
          'signature_date__gte': this.startDate.clone().startOf('month').format('DD/MM/YYYY'),
          'signature_date__lte': this.today.clone().endOf('day').format('DD/MM/YYYY')
        }
        let reservedRequest = await this.$api.advService.get(reservedQuery)

        let canceledQuery = {
          'cached': 1,
          'status': 'canceled_by_admin',
          'signature_date__gte': this.startDate.clone().startOf('month').format('DD/MM/YYYY'),
          'signature_date__lte': this.today.clone().endOf('day').format('DD/MM/YYYY')
        }
        let canceledRequest = await this.$api.advService.get(canceledQuery)
        return [...reservedRequest.data.items, ...soldRequest.data.items, ...canceledRequest.data.items]
      },
      loadMoreUsers (page) {
        this.$apollo.queries.users.fetchMore({
          variables: {
            page: page
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            let users = [...previousResult.users.users]
            fetchMoreResult.users.users.forEach(user => {
              let exists = users.find(x => x.pk === user.pk)
              if (!exists) {
                users.push(user)
              }
            })
            return {
              users: {
                __typename: previousResult.users.__typename,
                users,
                page: fetchMoreResult.users.page,
                pages: fetchMoreResult.users.pages
              }
            }
          }
        })
      },
      loadPendingDenunciationsCount (page = 1) {
        let query = {
          per_page: 100,
          status: ['pending'],
          page
        }
        this.$api.denunciationService.get(query).then(r => {
          let newDenunciation = r.data.items
          this.pendingDenunciations = this.pendingDenunciations.concat(newDenunciation)
          this.$store.commit('setRunningDenunciations', {denunciations: this.pendingDenunciations})
          if (page < r.data.pages) {
            page++
            this.loadPendingDenunciationsCount(page)
          }
        })
      },
      loadUsersCount (page = 1) {
        this.$api.userService.get({ page }).then(r => {
          let userPks = this.users.map(x => x.pk)
          let newUsers = r.data.items.filter(x => !userPks.includes(x.pk))
          this.users = this.users.concat(newUsers)
          if (r.data.page < r.data.pages) {
            page++
            this.loadUsersCount(page)
          }
        })
      },
      loadYearSalesData () {
        let startDate = this.startDate.clone().startOf('year')
        let endDate = this.endDate.clone().endOf('year')
        let statsParams = {
          status: ['sold', 'reserved'],
          start_date: startDate.format('DD/MM/YYYY'),
          end_date: endDate.format('DD/MM/YYYY')
        }
        this.$api.statisticService.getSaleData(statsParams).then(r => {
          this.yearSales = r.data.sales
        })
      },
      async loadFutureRdvs () {
        let params = {
          date__gte: moment().format('DD/MM/YYYY'),
          date__lte: moment().endOf('year').format('DD/MM/YYYY'),
          per_page: 1,
          cached: 1
        }
        let request = await this.$api.rdvService.get(params)
        this.futureRdvCount = request.data.total
      },
      updateStartDate (d) {
        this.rawStartDate = d
        if (this.rawEndDate < d) {
          this.rawEndDate = this.startDate.endOf('month').toDate()
        }
        this.loadSalesData()
      },
      updateEndDate (d) {
        this.rawEndDate = d
        this.loadSalesData()
      }
    },
    created () {
      this.token = localStorage.getItem('token')
      this.rawStartDate = moment().startOf('year').toDate()
      this.rawEndDate = moment().endOf('day').toDate()
      this.loadData()
      if (this.statsEnabled) {
        this.panel = PANELS.ACTIVITY
      } else {
        this.panel = PANELS.MONITORING
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/DashboardStats.vue